module.exports = __webpack_public_path__ + "img/clock-circle-svgrepo-com.b58161bd.svg";